import React from 'react'
import { Select } from 'antd'

export const statusFilterMethod = (filter, row) => {
  const openArray = ['New', 'Open']
  const closedArray = ['Closed', 'Archived']

  if (filter.value === 'All') {
    return true
  }
  if (filter.value === 'Closed') {
    return closedArray.includes(row[filter.id])
  }
  if (filter.value === 'New') {
    return row[filter.id] === 'New'
  }

  if (filter.value === 'Open') {
    return row[filter.id] === 'Open'
  }
  /*if (filter.value === 'assigned') {
    return row[filter.id] === 'Assigned'
  }
  if (filter.value === 'escalated') {
    return row[filter.id] === 'Escalated'
  }*/
  if (filter.value === 'Archived') {
    return row[filter.id] === 'Archived'
  }

  return filter.value === true
    ? openArray.includes(row[filter.id])
    : closedArray.includes(row[filter.id])
}

function StatusFilter({ onChange, filter }) {
  console.log({ filter })
  return (
    <Select
      onChange={value => onChange(value)}
      style={{ width: '100%' }}
      value={filter ? filter.value : 'All'}>
      <Select.Option value={'Open'}>Open</Select.Option>
      <Select.Option value={'New'}>New</Select.Option>
      {/* <Select.Option value={'assigned'}>Assigned</Select.Option>
      <Select.Option value={'escalated'}>Escalated</Select.Option>*/}
      <Select.Option value={'Closed'}>Closed</Select.Option>
      <Select.Option value={'Archived'}>Archived</Select.Option>
      <Select.Option value="All">All</Select.Option>
    </Select>
  )
}

StatusFilter.propTypes = {}
StatusFilter.defaultProps = {}

export default StatusFilter
